<script >

export default {
	name: "GoogleAuth.vue"
};
</script>

<template>
<div></div>
</template>
